import React from "react";
import "../styles/fun.css";
import LocalNavbar from "../components/localnavbar";

const Fun = () => {
  const projects = [
    {
      name: "Legal Watch Dog",
      description: "AI-Powered Regulatory Intelligence that scans and tracks policy changes an organization may want to monitor.",
      imgSrc: "/img/legalwatchdog.jpeg",
      technologies: ["FastAPI", "PostgreSQL", "MinIO", "Redis", "AI Tools"],
      link: "https://legalwatch.dog/",
    },
    {
      name: "LiveLedger",
      description: "A gas-efficient payment DApp that lets payers set a payment rate over time for real-time streaming payments.\n Recipients see their balance grow live and can withdraw accrued funds anytime within a daily limit.",
      imgSrc: "/img/liveledger.jpeg",
      technologies: ["Solidity", "EVM", "Web3", "Next.js", "Smart Contracts"],
      link: "https://live-ledger-client.vercel.app/",
    },
    {
      name: "Code2Nature",
      description:
        "A gamefied app that encorages devs to go out and connect with nature, gives locked points for coding activities,\n by maual entry or tracking from github, points are unlocked by doing activities",
      imgSrc: "/img/code2nature.png",
      technologies: ["Django", "ReactJS/Typescript", "PostgreSQL"],
      link: "https://code2nature.vercel.app/",
    },
    {
      name: "ZodiacCal",
      description: "A fun app to explore zodiac signs and their compatibility.",
      imgSrc: "/img/zodiacCalWeb.png",
      technologies: ["ReactJS"],
      link: "https://zodiac-cal.vercel.app/",
    },
    {
      name: "TaskTidy",
      description:
        "An intuitive task management app to keep your life organized.",
      imgSrc: "/img/taskTidyWeb.png",
      technologies: ["ReactJS", "ExpressJS", "MongoDB"],
      link: "http://task-tracker-nine-delta.vercel.app/",
    },
    {
      name: "summitGrid",
      description: "An event listing website",
      imgSrc: "/img/summitGridWeb.png",
      technologies: ["ReactJS", "ExpressJS", "MongoDB"],
      link: "https://summit-grid.vercel.app/",
    },
  ];

  return (
    <div className="justthere">
      <div className="fun">
        <LocalNavbar />
        <h1>Code & Adventures</h1>
        <h2>Here are some fun projects that I enjoyed building</h2>
        <ul>
          {projects.map((project, index) => (
            <li className="fun-card" key={index}>
              <h3>{project.name}</h3>
              <p> <strong>{project.description.split('\n').map((line, index) =>
              <span key={index}>
                {line}
                <br />
                <br />
              </span>)}
              </strong>
              </p>
              <img src={project.imgSrc} alt={project.name} />
              <p>
                <b>Tech Used:</b>{" "}
                {project.technologies.map((tech, index) => (
                  <span key={index} className="tech">
                    {tech}
                    {index < project.technologies.length - 1 ? ", " : ""}
                  </span>
                ))}
              </p>
              <p>
                <a
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <b><i>Check it out</i></b>
                </a>
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Fun;
